import { DomainContext } from 'context/DomainContext';
import { useContext } from 'react';

const useError = () => {
  const { error, notification, setError, setNotification } =
    useContext(DomainContext);

  return {
    error,
    notification,
    setError,
    setNotification,
  };
};

export default useError;
